import { FunctionComponent } from 'react';
import Image from 'next/image';

import { TypeBackgroundImageProps } from './types';

/**
 * BackgroundImage
 */
export const BackgroundImage: FunctionComponent<TypeBackgroundImageProps> = ({
  backgroundImage,
  overlay,
  notLazy = false,
}: TypeBackgroundImageProps) => (
  <>
    {backgroundImage ? (
      typeof backgroundImage !== 'string' ? (
        <picture className="absolute inset-0 pointer-events-none bg-black">
          {backgroundImage.srcset.map((source, index) => (
            <source media={source.media} srcSet={source.src} key={index} />
          ))}
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src={backgroundImage.src}
            alt={backgroundImage.alt ?? ''}
            loading={notLazy ? undefined : 'lazy'}
            className="w-full h-full object-contain object-center"
          />
        </picture>
      ) : (
        <Image
          src={backgroundImage}
          alt="Card Background"
          className="w-full h-full object-cover object-center absolute inset-0"
          draggable="false"
          priority={notLazy}
          sizes="100vw"
          fill
        />
      )
    ) : null}
    {overlay && overlay != 0 ? (
      <div className="bg-black absolute inset-0" style={{ opacity: overlay }} />
    ) : null}
  </>
);
